import * as React from "react";
import { FormattedMessage } from "react-intl";
import { PathProvider } from "./path";
import { PathBreadcrumb } from "./PathBreadcrumb";
import { Title } from "./Title";
import { SchemaTable } from "./SchemaTable";
import { AdvancedOptions, ShowAdvancedOptionsButton } from "./AdvancedOptions";
import { Errors } from "./Errors";
import { Footer } from "./Footer";
import { useStateContext } from "./state";

export const InferContents = () => {
  const { editable } = useStateContext();
  const [showAdvanced, setShowAdvanced] = React.useState(false);
  return (
    <PathProvider>
      <Title />
      <div className="grid grid-cols-[1fr_0fr] sm:grid-cols-[auto_1fr_auto] sm:gap-3 items-center -mb-2">
        <h3 className="text-xl font-semibold">
          {editable ? (
            <FormattedMessage defaultMessage="Edit Schema" />
          ) : (
            <FormattedMessage defaultMessage="Schema" />
          )}
        </h3>
        {editable && (
          <ShowAdvancedOptionsButton
            className="sm:order-last"
            showAdvanced={showAdvanced}
            setShowAdvanced={setShowAdvanced}
          />
        )}
        <PathBreadcrumb />
      </div>
      <div className="overflow-auto space-y-8">
        {showAdvanced && <AdvancedOptions />}
        <Errors />
        <SchemaTable />
      </div>
      <Footer />
    </PathProvider>
  );
};
